<template>
  <div v-if="totalCells > 0" class="bingo-progress text-body-2 mb-3">
    {{ markedCount }} / {{ totalCells }} {{ progressLabel }}
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'BingoProgress',
  computed: {
    ...mapGetters('bingo', ['markedCount', 'totalCells']),
    ...mapState('bingo', ['boardMode']),
    progressLabel() {
      return this.boardMode === 'categories'
        ? 'visited'
        : 'visited';
    }
  }
};
</script>

<style lang="scss" scoped>
.bingo-progress {
  color: rgba(0, 0, 0, .6) !important;
  font-weight: 500;
  font-size: .875rem !important;
  line-height: 1.25rem !important;
}
</style>
